import { memo } from 'react'
import Video from './Video'
import VideoOff from './VideoOff'

interface IVideocam {
    active?: boolean
}

const Videocam = memo((props: IVideocam) => {
    const { active = true } = props
    return active ? <Video /> : <VideoOff />
})

export default Videocam
